import { parseISO } from 'date-fns';

// email_sends.sent_at is a naive UTC timestamp; without the marker the
// browser would read it as local time and show Jim 8:43 PM for a 3:43 PM send.
export function sentAtUtc(sentAt: string): Date {
  return parseISO(/(Z|[+-]\d\d:?\d\d)$/.test(sentAt) ? sentAt : `${sentAt}Z`);
}
